/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    start?: number;
}

/**
 * Check if a given object implements the Pageable interface.
 */
export function instanceOfPageable(value: object): value is Pageable {
    return true;
}

export function PageableFromJSON(json: any): Pageable {
    return PageableFromJSONTyped(json, false);
}

export function PageableFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pageable {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'] == null ? undefined : json['limit'],
        'start': json['start'] == null ? undefined : json['start'],
    };
}

export function PageableToJSON(json: any): Pageable {
    return PageableToJSONTyped(json, false);
}

export function PageableToJSONTyped(value?: Pageable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'start': value['start'],
    };
}

